var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Paper',{staticClass:"section-header-root p-3 mb-3 d-flex align-items-center"},[_c('h6',{staticClass:"mb-0 heading"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"flex-grow"},[_vm._t("left")],2),_vm._t("right")],2)}
var staticRenderFns = []

export { render, staticRenderFns }